import React from "react";
import Marquee from "react-fast-marquee";
import { useLang } from "@/i18n/LanguageContext";

export default function TrustMarquee() {
  const { t } = useLang();
  return (
    <section className="py-8 border-y border-white/5 bg-[#0A0A0A]">
      <Marquee gradient={false} speed={40} pauseOnHover>
        {t.trust.items.map((item, i) => (
          <span className="marquee-item" key={i}>
            <span className="marquee-dot" />
            {item}
          </span>
        ))}
      </Marquee>
    </section>
  );
}
